export const readFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
            resolve(e.target.result);
        }
        reader.onerror = e => {
            reject(e);
        }
    })
}

export function delCookie (name) {
    let time = 24 * 60 * 60 * 1000;
    let exp = new Date();
    let expires = new Date(exp - time);
    document.cookie=name+'=' + '' + ';expires='+expires.toGMTString()+';path=/';
}

export function getCookie(name) {
    let reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    let arr = document.cookie.match(reg);
    if(arr) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

export function isJSON(str) {
    if (!str) {
        return true
    }
    if (typeof str == 'string') {
        try {
            let obj=JSON.parse(str);
            return typeof obj == 'object' && obj

        } catch(e) {
            return false;
        }
    }
    return false;
}

export function isDateTime(str) {
    if (!str) {
        return true;
    }
    let patt = /^\d{8}T\d{6}Z$/
    return patt.test(str)
}

export function isProductName(str) {
    let reg = /^[A-Za-z0-9_-]+$/;
    return reg.test(str)
}

export function isCompanyName(str) {
    let reg = /^[\u4e00-\u9fa5a-zA-Z0-9_-]+$/;
    return reg.test(str)
}

export function isDeviceName(str) {
    let reg = /^[\u4e00-\u9fa5a-zA-Z0-9,，()（）?@!！&%.'#_-]+$/;
    return reg.test(str)
}

export function isServiceId(str) {
    let reg = /^[A-Za-z0-9_]+$/;
    return reg.test(str)
}

export function isServiceId2(str) {
    let reg = /^[A-Za-z]+/;
    return reg.test(str)
}

export function isNumber(str) {
    if (!str) {
        return true
    }
    let reg = /^\d+$/;
    return reg.test(str)
}

export function isDynamicNumber(str) {
    if (!str) {
        return true
    }
    let reg = /^-?\d+$/;
    return reg.test(str)
}

export function isIntOrFloat(val){
    if (!val) {
        return true
    }
    let reg = /^(-?\d+)(\.\d+)?$/
    return reg.test(val);
}

export function isEnum(str) {
    let reg = /^[A-Za-z,]+$/;
    return reg.test(str)
}